<template>
	<div class="checkbox-manager">
		<label class="checkbox-manager__search" v-if="search && allItems.length > 7">
			<span>Search </span>
			<input type="text" v-model="filter">
		</label>
		<div class="checkbox-manager__unchecked">
			<button type="button" class="button button--text" @click.prevent="selectAll">Select All</button>
			<div>
				<label v-for="(item, key) in uncheckedItems">
					<span v-html="itemLabel(item)"></span>
					<input type="checkbox" :value="itemValue(item)" v-on:click="check(item)">
				</label>
			</div>
		</div>
		<div class="checkbox-manager__checked">
			<button type="button" class="button button--text" @click.prevent="deselectAll">Deselect All</button>
			<div>
				<label v-for="(item, key) in checkedItems">
					<span v-html="itemLabel(item)"></span>
					<input type="checkbox" :value="itemValue(item)" v-on:click="uncheck(item)">
				</label>
			</div>
		</div>
		<div class="checkbox-manager__help-block" v-if="$attrs.helpBlock">
			<p v-html="$attrs.helpBlock"></p>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			localCheckedItems: [],
			filter: "",
		};
	},

	props: {
		search: {
			type: Boolean,
			default() {
				return true;
			}
		},
		refItems: {
			type: String,
			default() {
				return null;
			}
		},
		allItems: {
			type: Array,
			default() {
				return [];
			}
		},
		checked: {
			type: Array,
			default() {
				return [];
			}
		},
	},

	watch: {
		items: function (items) {
			let filteredItems = _.filter(this.localCheckedItems, id => {
				return _.indexOf(_.map(items, item => item.id), id) !== -1;
			});

			if (filteredItems.length === this.localCheckedItems.length) {
				return;
			}

			this.localCheckedItems = filteredItems;

			this.$emit("valuesChanged", this.localCheckedItems);
		},
	},

	computed: {
		referencedItems() {
			if (!this.refItems) {
				return null;
			}
			return this.$parent.$refs[this.refItems].checkedItems;
		},
		items() {
			if (!this.refItems) {
				return this.allItems;
			}
			return this.referencedItems;
		},
		filteredItems() {
			var filter = this.filter.toLowerCase();

			if (filter === "") {
				return this.items;
			}

			return _.filter(this.items, item => {
				return this.itemLabel(item).toLowerCase().startsWith(filter);
			});
		},
		uncheckedItems() {
			return this.sort(_.filter(this.filteredItems, item => {
				return !this.isChecked(item);
			}));
		},
		checkedItems() {
			return this.sort(_.filter(this.filteredItems, item => {
				return this.isChecked(item);
			}));
		},
	},
	methods: {
		isChecked(item) {
			return this.checked.indexOf(item) >= 0;
		},
		sort(items) {
			return _.sortBy(items, this.$attrs.itemLabel || "label");
		},
		itemKey(item) {
			return _.get(item, this.$attrs.itemkey || "id");
		},
		itemLabel(item) {
			if (this.$attrs.itemLabelRender) {
				return this.$attrs.itemLabelRender(item);
			}
			return _.get(item, this.$attrs.itemLabel || "label");
		},
		itemValue(item) {
			return _.get(item, this.$attrs.itemkey || "id");
		},
		check(item, fireEvent) {
			this.localCheckedItems.push(this.itemValue(item));

			if (false === fireEvent) {
				return;
			}

			this.$emit("valuesChanged", this.localCheckedItems.slice());
		},
		uncheck(item, fireEvent) {
			this.localCheckedItems.splice(this.localCheckedItems.indexOf(this.itemValue(item)), 1);

			if (false === fireEvent) {
				return;
			}

			this.$emit("valuesChanged", this.localCheckedItems.slice());
		},
		setChecked(items) {
			for (var i in items) {
				var item = _.get(items, i);
				this.check(item, false);
			}

			this.$emit("valuesChanged", this.localCheckedItems.slice());
		},
		setUnchecked(items) {
			for (var i in items) {
				var item = _.get(items, i);
				this.uncheck(item, false);
			}

			this.$emit("valuesChanged", this.localCheckedItems.slice());
		},
		selectAll() {
			this.setChecked(this.uncheckedItems);
		},
		deselectAll() {
			this.setUnchecked(this.checkedItems);
		},
	},

	created() {
		if (this.checked.length) {
			this.setChecked(this.checked);
		}
	}
};
</script>
